module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-caret-right",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('font', {
    staticStyle: {
      "color": "#048019"
    }
  }, [_vm._v("Pré-Análise da Proposta")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('fieldset', {
    attrs: {
      "disabled": this.$router.currentRoute.name === 'proposta-visualiza'
    }
  }, [_c('div', {
    staticClass: "form-horizontal"
  }, [(_vm.mostrarRef('agencia_condutora_agencia')) ? _c('agencia-condutora-projeto', {
    attrs: {
      "propsProposta": _vm.preAnalise
    },
    on: {
      "agenciaSelecionada": _vm.preAnalise.agencia
    }
  }) : _vm._e(), _vm._v(" "), _c('fep', {
    attrs: {
      "propsPreAnalise": _vm.preAnalise
    }
  }), _vm._v(" "), _c('categorizadores', {
    attrs: {
      "propsPreAnalise": _vm.preAnalise
    }
  }), _vm._v(" "), (_vm.mostrarRef('restricoes')) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 required"
  }, [_c('div', {
    staticClass: "box box-widget"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body form-group required-field",
    class: {
      'has-error': _vm.errors.first('calculo de rating')
    },
    staticStyle: {
      "padding-top": "0px"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("Cálculo de rating")]), _vm._v(" "), _c('div', _vm._l((_vm.rating), function(r) {
    return _c('div', {
      staticClass: "col-sm-2"
    }, [_c('label', {
      staticClass: "new-control new-control-radio",
      staticStyle: {
        "padding-top": "8px",
        "margin-left": "15px"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.preAnalise.rating),
        expression: "preAnalise.rating"
      }, {
        name: "validate",
        rawName: "v-validate",
        value: ('required'),
        expression: "'required'"
      }],
      attrs: {
        "type": "radio",
        "name": "calculo de rating"
      },
      domProps: {
        "value": r.id,
        "checked": _vm._q(_vm.preAnalise.rating, r.id)
      },
      on: {
        "change": function($event) {
          return _vm.$set(_vm.preAnalise, "rating", r.id)
        }
      }
    }), _vm._v("\n                        " + _vm._s(r.description) + "\n                        "), _c('div', {
      staticClass: "new-control-indicator"
    })])])
  }), 0)]), _vm._v(" "), (_vm.errors.first('calculo de rating')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('calculo de rating')))]) : _vm._e()])])])]) : _vm._e(), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Documentos da Proposta")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('upload-documentos-php-novo', {
    attrs: {
      "propDocumentos": _vm.preAnalise.documentos,
      "documentTypes": '',
      "documentosObrigatorios": '',
      "localUso": _vm.listaDocEntidades
    }
  })], 1)]), _vm._v(" "), _c('fieldset', [_c('legend', [_vm._v("Aprovação")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "form-group required full",
    class: {
      'has-error': _vm.errors.first('resultado pre-analise')
    },
    staticStyle: {
      "margin-right": "0",
      "margin-left": "0"
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "resultado pre-analise"
    }
  }, [_vm._v("Ação sobre a proposta:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "radio-inline new-control new-control-radio\n"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preAnalise.resultadoAprovacao),
      expression: "preAnalise.resultadoAprovacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "resultado pre-analise",
      "id": "resultado pre-analise",
      "data-vv-as": "Resultado da Pré-análise",
      "value": "APROVAR"
    },
    domProps: {
      "checked": _vm._q(_vm.preAnalise.resultadoAprovacao, "APROVAR")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.preAnalise, "resultadoAprovacao", "APROVAR")
      }
    }
  }), _vm._v(" Aprovar\n                  "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "radio-inline new-control new-control-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preAnalise.resultadoAprovacao),
      expression: "preAnalise.resultadoAprovacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "resultado pre-analise",
      "data-vv-as": "Resultado da Pré-análise",
      "value": "ENVIAR_REVISAO"
    },
    domProps: {
      "checked": _vm._q(_vm.preAnalise.resultadoAprovacao, "ENVIAR_REVISAO")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.preAnalise, "resultadoAprovacao", "ENVIAR_REVISAO")
      }
    }
  }), _vm._v(" Revisão\n                  "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "radio-inline new-control new-control-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preAnalise.resultadoAprovacao),
      expression: "preAnalise.resultadoAprovacao"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "resultado pre-analise",
      "data-vv-as": "Resultado da Pré-análise",
      "value": "REPROVAR"
    },
    domProps: {
      "checked": _vm._q(_vm.preAnalise.resultadoAprovacao, "REPROVAR")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.preAnalise, "resultadoAprovacao", "REPROVAR")
      }
    }
  }), _vm._v(" Reprovado\n                  "), _c('div', {
    staticClass: "new-control-indicator"
  })])])]), _vm._v(" "), (_vm.errors.first('resultado pre-analise')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('resultado pre-analise')))]) : _vm._e(), _vm._v(" "), (_vm.preAnalise.resultadoAprovacao && _vm.preAnalise.resultadoAprovacao !== 'APROVAR') ? _c('div', {
    staticClass: "form-group required full",
    class: {
      'has-error': _vm.errors.first('justificativa')
    },
    staticStyle: {
      "margin-right": "0",
      "margin-left": "0"
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "justificativa"
    }
  }, [_vm._v("Justificativa:")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.preAnalise.preAnaliseJustificativa),
      expression: "preAnalise.preAnaliseJustificativa"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "150px",
      "resize": "none"
    },
    attrs: {
      "name": "justificativa",
      "id": "justificativa"
    },
    domProps: {
      "value": (_vm.preAnalise.preAnaliseJustificativa)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.preAnalise, "preAnaliseJustificativa", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('justificativa')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('justificativa')))]) : _vm._e()]) : _vm._e()])])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Cálculo de Rating")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1fdd2132!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/validação/proposta/preAnaliseForm.vue
// module id = 1825
// module chunks = 2